import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SalesInvoiceAddComponent } from "src/app/components/invoices/sales/add/add.component";
import { SalesInvoiceEditComponent } from "src/app/components/invoices/sales/edit/edit.component";
import { SalesInvoiceListComponent } from "src/app/components/invoices/sales/list/list.component";
import { SupplementaryInvoiceAddComponent } from "src/app/components/invoices/supplementary/add/add.component";
import { SupplementaryInvoiceListComponent } from "src/app/components/invoices/supplementary/list/list.component";
import { SupplementaryInvoiceViewComponent } from "src/app/components/invoices/supplementary/view/view.component";
import { VendorReconciliationComponent }  from "src/app/components/invoices/vendorreco/vendorreco.component";

const routes: Routes = [
    { path: 'sales', component: SalesInvoiceListComponent },
    { path: 'sales/add', component: SalesInvoiceAddComponent },
    { path: 'sales/edit/:id', component: SalesInvoiceEditComponent },
    { path: 'sales/view/:id', component: SalesInvoiceEditComponent },
    { path: 'supplementary', component: SupplementaryInvoiceListComponent },
    { path: 'supplementary/add', component: SupplementaryInvoiceAddComponent },
    { path: 'supplementary/view/:id', component: SupplementaryInvoiceViewComponent },    
    { path: 'vendorreco', component: VendorReconciliationComponent },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class InvoiceRoutingModule { }